import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import constants from '../config';
import { resolveCardImage } from '../utils/resolveImage';

var conditionMap = { 'NM': 'Near Mint', 'LP': 'Lightly Played', 'MP': 'Moderately Played' };

function getStatusBadge(status) {
  var colors = {
    pending: { bg: '#fef3c7', color: '#92400e', label: 'Pending' },
    accepted: { bg: '#d1fae5', color: '#065f46', label: 'Accepted' },
    declined: { bg: '#fee2e2', color: '#991b1b', label: 'Declined' },
    countered: { bg: '#dbeafe', color: '#1e40af', label: 'Countered' },
    expired: { bg: '#f3f4f6', color: '#6b7280', label: 'Expired' },
    completed: { bg: '#d1fae5', color: '#065f46', label: 'Completed' },
  };
  var s = colors[status] || colors.pending;
  return s;
}

function getTimeRemaining(expiresAt) {
  var now = new Date();
  var exp = new Date(expiresAt);
  var diff = exp - now;
  if (diff <= 0) return 'Expired';
  var hours = Math.floor(diff / (1000 * 60 * 60));
  var mins = Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60));
  if (hours > 0) return hours + 'h ' + mins + 'm remaining';
  return mins + 'm remaining';
}

class BuylistOfferCard extends Component {
  constructor(props) {
    super(props);
    this.state = {
      responding: false,
      counterMode: false,
      counterItems: [],
    };
  }

  render() {
    var self = this;
    var offer = this.props.offer;
    if (!offer) return null;

    var isDark = document.documentElement.classList.contains('tw-dark');
    var status = getStatusBadge(offer.status);
    var isBuyer = this.props.isBuyer;
    var isPending = offer.status === 'pending';
    var isAccepted = offer.status === 'accepted';

    return (
      <div className="tw-rounded-xl tw-overflow-hidden tw-my-2" style={{ border: '2px solid #c9a84c', maxWidth: '400px' }}>
        {/* Header */}
        <div className="tw-px-3 tw-py-2 tw-flex tw-items-center tw-justify-between" style={{ background: isDark ? '#2a2500' : '#fdf8e8' }}>
          <div className="tw-flex tw-items-center tw-gap-2">
            <i className="fa fa-list" style={{ color: '#c9a84c' }}></i>
            <span className="tw-text-sm tw-font-semibold" style={{ color: isDark ? '#e5d7a0' : '#8b6914' }}>Buylist Offer</span>
          </div>
          <span className="tw-text-xs tw-font-medium tw-px-2 tw-py-0.5 tw-rounded-full" style={{ background: status.bg, color: status.color }}>
            {status.label}
          </span>
        </div>

        {/* Items */}
        <div className="tw-bg-white dark:tw-bg-[#1a1a1a]">
          {offer.items && offer.items.map(function(item, idx) {
            var card = item.card;
            var cardImg = resolveCardImage(card && card.image ? card.image : null);
            return (
              <div key={idx} className="tw-flex tw-items-center tw-gap-2.5 tw-px-3 tw-py-2 tw-border-b tw-border-[#e0e0e0] dark:tw-border-[#333]">
                {cardImg ? (
                  <img src={cardImg} alt={card.name} className="tw-w-8 tw-h-11 tw-object-cover tw-rounded" />
                ) : (
                  <div className="tw-w-8 tw-h-11 tw-rounded tw-flex tw-items-center tw-justify-center" style={{ background: isDark ? '#222' : '#f0f0f0' }}>
                    <i className="fa fa-image tw-text-xs tw-text-[#999]"></i>
                  </div>
                )}
                <div className="tw-flex-1 tw-min-w-0">
                  <p className="tw-text-xs tw-font-medium tw-text-[#111] dark:tw-text-white tw-m-0 tw-truncate">{card ? card.name : 'Card'}</p>
                  <p className="tw-text-xs tw-text-[#999] tw-m-0">
                    {conditionMap[item.condition] || item.condition}{item.foil ? ' (Foil)' : ''} | x{item.quantity}
                  </p>
                </div>
                <span className="tw-text-sm tw-font-semibold" style={{ color: '#16a34a' }}>
                  ${(item.pricePerCopy * item.quantity).toFixed(2)}
                </span>
              </div>
            );
          })}
        </div>

        {/* Footer */}
        <div className="tw-px-3 tw-py-2 tw-bg-white dark:tw-bg-[#1a1a1a]">
          {/* Total */}
          <div className="tw-flex tw-items-center tw-justify-between tw-mb-1">
            <span className="tw-text-xs tw-text-[#999]">Total</span>
            <span className="tw-text-base tw-font-bold" style={{ color: '#16a34a' }}>${offer.totalAmount.toFixed(2)}</span>
          </div>

          {/* Timer */}
          {isPending && offer.expiresAt && (
            <p className="tw-text-xs tw-text-[#999] tw-text-center tw-mb-2">
              <i className="fa fa-clock-o tw-mr-1"></i>{getTimeRemaining(offer.expiresAt)}
            </p>
          )}

          {/* Seller Note */}
          {offer.sellerNote && (
            <p className="tw-text-xs tw-text-[#666] dark:tw-text-[#999] tw-italic tw-mb-2 tw-px-2 tw-py-1.5 tw-rounded" style={{ background: isDark ? '#222' : '#f5f5f5' }}>
              "{offer.sellerNote}"
            </p>
          )}

          {/* Buyer Actions */}
          {isBuyer && isPending && (
            <div className="tw-flex tw-gap-2 tw-mt-2">
              <button
                onClick={function() { self.props.onRespond(offer._id, 'accept'); }}
                disabled={self.state.responding}
                className="tw-flex-1 tw-py-2 tw-rounded-lg tw-text-xs tw-font-semibold tw-border-none tw-cursor-pointer tw-transition-colors"
                style={{ background: '#16a34a', color: '#fff' }}
              >
                Accept
              </button>
              <button
                onClick={function() { self.props.onRespond(offer._id, 'counter'); }}
                disabled={self.state.responding}
                className="tw-flex-1 tw-py-2 tw-rounded-lg tw-text-xs tw-font-semibold tw-border-none tw-cursor-pointer tw-transition-colors"
                style={{ background: '#c9a84c', color: '#000' }}
              >
                Counter
              </button>
              <button
                onClick={function() { self.props.onRespond(offer._id, 'decline'); }}
                disabled={self.state.responding}
                className="tw-flex-1 tw-py-2 tw-rounded-lg tw-text-xs tw-font-semibold tw-border-none tw-cursor-pointer tw-transition-colors"
                style={{ background: '#ef4444', color: '#fff' }}
              >
                Decline
              </button>
            </div>
          )}

          {/* Accepted - checkout link */}
          {isBuyer && isAccepted && (
            <Link
              to={'/buylist/checkout/' + offer._id}
              className="tw-block tw-text-center tw-py-2.5 tw-rounded-lg tw-text-sm tw-font-semibold tw-no-underline tw-mt-2"
              style={{ background: '#16a34a', color: '#fff' }}
            >
              Buy Now - ${offer.totalAmount.toFixed(2)}
            </Link>
          )}
        </div>
      </div>
    );
  }
}

export default BuylistOfferCard;
